module.exports = __webpack_public_path__ + "img/Shortslike.2fe8addc.svg";